/*
*
* Utility class initializations
*
*/

(function () {

  // Init hires bgs
  const hiresBgElements = document.getElementsByClassName('js-highres-bg');
  if (hiresBgElements.length) {
    import('./modules/hires-background').then((hiresBg)=> {
      hiresBg.default.init(hiresBgElements);
    });
  }

  // Init read more utility
  const readMoreElements = document.getElementsByClassName('js-read-more-text');
  if (readMoreElements.length) {
    import('./modules/read-more').then(({ Readmore }) => {
      for (var i = 0; i < readMoreElements.length; i++) {
        new Readmore(readMoreElements[i]);
      }
    });
  }

  // Init dropdown utility
  const dropdownElements = document.getElementsByClassName('js-dropdown');
  if (dropdownElements.length) {
    import('./modules/dropdown').then(({ Dropdown }) => {
      for (var i = 0; i < dropdownElements.length; i++) {
        new Dropdown(dropdownElements[i]);
      }
    });
  }

})();
